<ul class="breadcrumb breadcrumb-page">
  <li><a href="#">{{'app.Home' | translate}}</a></li>
  <li class="active">{{'pageHeader.workingDays' | translate}}</li>
</ul>

<div class="page-header">
  <div class="row">
    <h1 class="col-xs-12 col-sm-4 text-center text-left-sm"><img [src]="logo" class="img-icon" />&nbsp;&nbsp;{{'pageHeader.workingDays' | translate}}</h1>
  </div>
</div>

<div class="panel panel-success widget-support-tickets">
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-12">
          <p class="text-muted" *ngIf="displayMode==2">Drag rows to arrange your week.</p>
          <table class="table" *ngIf="displayMode==2">
            <thead>
              <tr>
                <th width="5%"></th>
                <th>{{'app.name' | translate}}</th>
                <th width="7%">Am</th>
                <th width="7%">Pm</th>
              </tr>
            </thead>
            <tbody cdkDropList (cdkDropListDropped)="drop($event)">
              <tr *ngFor="let workingDay of workingDays; let i = index" cdkDrag>
                <td class="drag-handle" cdkDragHandle><i class="fa fa-bars"></i></td>
                <td>
                  {{ workingDay.name }}
                </td>
                <td>
                  <label class="switch">
                    <input type="checkbox" [checked]="workingDay.amActive" (click)="DoAmCheck(workingDay.id)">
                    <span class="slider round"></span>
                  </label>
                </td>
                <td>
                  <label class="switch">
                    <input type="checkbox" [checked]="workingDay.pmActive" (click)="DoPmCheck(workingDay.id)">
                    <span class="slider round"></span>
                  </label>
                </td>
              </tr>
              <tr *ngIf="workingDays.length==0">
                <td colspan="4">{{'app.NoDataFound' | translate}}</td>
              </tr>
            </tbody>
          </table>
          <div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==1">
            <div class="container text-center">
              <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
            </div>
          </div>
          <div class="alert alert-danger alert-dark" *ngIf="displayMode==3">
            <button type="button" class="close" data-dismiss="alert">×</button>
            {{'app.ServerError' |translate}}.
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
